<template>
  <div class="register">
    <div class="header">技通天下学习平台  ——  注册</div>
    <div class="content">
      <el-form :model="registerValidateForm" ref="registerValidateForm" :rules="registerRule" label-width="100px" class="demo-dynamic">
<!--        <el-form-item prop="userName" label="姓名">-->
<!--          <el-input placeholder="请输入用户名" v-model="registerValidateForm.userName"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item prop="telephone" label="手机号">
          <el-input placeholder="请输入手机号" v-model="registerValidateForm.telephone"></el-input>
        </el-form-item>
<!--        <el-form-item prop="shenfen" label="身份证号">-->
<!--          <el-input placeholder="请输入身份证号" v-model="registerValidateForm.shenfen"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="gender" label="性别">-->
<!--          <el-radio-group v-model="registerValidateForm.gender">-->
<!--            <el-radio :label="0">男</el-radio>-->
<!--            <el-radio :label="1">女</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="education" label="学历">-->
<!--          <el-select v-model="registerValidateForm.education" style="width: 100%" placeholder="请选择学历">-->
<!--            <el-option-->
<!--              v-for="item in educationList"-->
<!--              :key="item.code"-->
<!--              :label="item.name"-->
<!--              :value="item.code">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="identity" label="身份">-->
<!--          <el-select v-model="registerValidateForm.identity" style="width: 100%" placeholder="请选择身份">-->
<!--            <el-option-->
<!--              v-for="item in identityList"-->
<!--              :key="item.code"-->
<!--              :label="item.name"-->
<!--              :value="item.code">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item prop="userPwd" label="登录密码">
          <el-input placeholder="请输入密码" type="password" v-model="registerValidateForm.userPwd"></el-input>
        </el-form-item>
        <el-form-item prop="userApwd" label="确认密码">
          <el-input placeholder="请再次输入密码" type="password" v-model="registerValidateForm.userApwd"></el-input>
        </el-form-item>
        <el-form-item prop="smscode" label="验证码">
          <el-input placeholder="请输入验证码" v-model="registerValidateForm.smscode">
            <template slot="append">
              <el-button v-if="!isCode" @click="getCode">获取验证码</el-button>
              <div v-else>{{isTime}}s后重新发生</div>
            </template>
          </el-input>
        </el-form-item>
<!--        <el-form-item style="margin-bottom: 0px">-->
<!--          <el-radio-group v-model="registerValidateForm.type">-->
<!--            <el-radio :label="0">个人认证</el-radio>-->
<!--            <el-radio :label="1">企业认证</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="remember" style="margin-bottom: 0px">-->
<!--          <el-checkbox-group v-model="registerValidateForm.remember">-->
<!--            <el-checkbox label="同意" name="type"><span>我已阅读并同意 </span><a href="../../static/gvrp.html" target="_blank">《注册协议》</a></el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button class="buttonInfo" type="primary" @click="registerForm('registerValidateForm')">注册</el-button>
          <div class="blackLogin" @click="blackLogin">返回登录</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: "register",
    data() {
      let reg = /^1[3456789]\d{9}$/
      let phoneReg = (rule, value, callback) => {
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.registerValidateForm.userApwd !== '') {
            this.$refs.registerValidateForm.validateField('userApwd')
          }
          callback()
        }
      }
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.registerValidateForm.userPwd) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return{
        registerValidateForm: {
          // userName: '',
          telephone: '',
          // shenfen: '',
          // gender: 0,
          userPwd: '',
          userApwd: '',
          smscode: ''
          // remember: ['同意'],
          // name: '',
          // type: 0,
          // education: '',
          // identity: '',
          // invitationCode: ''
        },
        registerRule: {
          // userName: [{required: true, message:'请输入姓名', trigger: 'blur'}],
          // shenfen: [{required: true, message:'请输入身份证号', trigger: 'blur'}],
          // gender: [{required: true, message:'请选择性别', trigger: 'blur'}],
          // education: [{required: true, message:'请选择学历', trigger: 'blur'}],
          // identity: [{required: true, message:'请选择身份', trigger: 'blur'}],
          telephone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: phoneReg, trigger: 'blur' }],
          // name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          userPwd: [{ required: true, message: '请输入登录密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }],
          userApwd: [{ required: true, message: '请确认登录密码', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' }],
          smscode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
          // remember: [{ type: 'array', required: true, message: '请同意注册协议', trigger: 'change' }]
        },
        isCode: false,
        isTime: 60,
        sendModel: null,
        educationList: [],
        identityList: []
      }
    },
    mounted() {
    },
    methods:{
      // 获取短信验证码
      getCode() {
        let that = this
        if (that.registerValidateForm.telephone == '') {
          this.$message.error('请输入手机号')
        } else {
          that.isCode = true
          that.sendModel = setInterval(function () {
            if (that.isTime <= 0) {
              that.isTime = 60
              that.isCode = false
              clearInterval(that.sendModel)
            } else {
              that.isTime--
            }
          }, 1000)
          this.$http({
            method: 'POST',
            url: '/api/renren-fast/app/sys/registersms',
            data: {
              telephone: that.registerValidateForm.telephone
            }
          }).then((result) => {
            // console.log(result)
          })
        }
      },
      registerForm (formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.$http({
              method: 'POST',
              url: '/api/renren-fast/app/sys/registertemp',
              data: that.registerValidateForm
            }).then((result) => {
              if (result.data.code === 0) {
                this.$router.push('/login')
              } else {
                that.$message.error(result.data.msg)
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      // 获取身份列表
      // getEducation() {
      //   let that = this
      //   that.$http({
      //     method: 'GET',
      //     url: '/api/renren-fast/app/sys/getIdentity'
      //   }).then((result) => {
      //     if (result.data.code == 0) {
      //       that.identityList = result.data.data
      //     }
      //   })
      // },
      // 获取学历列表
      // getIdentity() {
      //   let that = this
      //   that.$http({
      //     method: 'GET',
      //     url: '/api/renren-fast/app/sys/getEducation'
      //   }).then((result) => {
      //     if (result.data.code == 0) {
      //       that.educationList = result.data.data
      //     }
      //   })
      // },
      blackLogin() {
        this.$router.push('/login')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .register{
    width: 100%;
    height: 100%;
    background: #fff;
    .header{
      width: 100%;
      height: 60px;
      background: #00c5c3;
      padding: 0px 210px;
      font-size: 24px;
      line-height: 60px;
      color: #ffffff;
    }
    .content{
      width: 500px;
      margin: 100px auto;
      .buttonInfo{
        width: 310px;
        height: 44px;
        background: linear-gradient(90deg,rgba(4,236,234,1) 0%,rgba(0,197,195,1) 100%);
        box-shadow: 0px 2px 22px 0px rgba(0,197,195,0.32);
        font-size: 18px;
        color: #ffffff;
        display: block;
        border: none;
        border-radius: 22px;
        margin-top: 20px;
        cursor: pointer;
      }
      .blackLogin{
        width: 310px;
        color: #00c5c3;
        text-align: end;
        cursor: pointer;
        margin-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/register.vue